var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@apollo/client';
import { UpdateEsigningGroupMessageDocument, UpdateEsigningSigningOrderDocument } from './update.gql';
import { useEsigning } from '../../components/EsigningProvider';
export const useUpdateEsigningSettings = () => {
    const { documentId: fileSystemDocumentId } = useEsigning();
    const [mutateSigningOrder] = useMutation(UpdateEsigningSigningOrderDocument);
    const [mutateGroupMessage] = useMutation(UpdateEsigningGroupMessageDocument);
    const updateSigningOrder = (requireOrder) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const { data } = yield mutateSigningOrder({
            variables: {
                fileSystemDocumentId,
                requireOrder,
            },
            update: (cache, result) => {
                var _a, _b;
                // eslint-disable-next-line no-underscore-dangle
                if (((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.updateDocumentEsigningSettings) === null || _b === void 0 ? void 0 : _b.__typename) === 'UpdateDocumentEsigningSettingsPayload') {
                    const { documentEsigningSettings } = result.data.updateDocumentEsigningSettings;
                    cache.modify({
                        fields: {
                            documentEsigningSettings() {
                                return documentEsigningSettings;
                            },
                        },
                    });
                }
            },
        });
        // eslint-disable-next-line no-underscore-dangle
        if (((_a = data === null || data === void 0 ? void 0 : data.updateDocumentEsigningSettings) === null || _a === void 0 ? void 0 : _a.__typename) === 'UpdateDocumentEsigningSettingsRejectionList') {
            throw Error('Failed to update signing order setting');
        }
    });
    const updateGroupMessage = (message) => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const { data } = yield mutateGroupMessage({
            variables: {
                fileSystemDocumentId,
                message,
            },
            update: (cache, result) => {
                var _a, _b;
                // eslint-disable-next-line no-underscore-dangle
                if (((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.updateDocumentEsigningSettings) === null || _b === void 0 ? void 0 : _b.__typename) === 'UpdateDocumentEsigningSettingsPayload') {
                    const { documentEsigningSettings } = result.data.updateDocumentEsigningSettings;
                    cache.modify({
                        fields: {
                            documentEsigningSettings() {
                                return documentEsigningSettings;
                            },
                        },
                    });
                }
            },
        });
        // eslint-disable-next-line no-underscore-dangle
        if (((_b = data === null || data === void 0 ? void 0 : data.updateDocumentEsigningSettings) === null || _b === void 0 ? void 0 : _b.__typename) === 'UpdateDocumentEsigningSettingsRejectionList') {
            throw Error('Failed to update group message setting');
        }
    });
    return { updateSigningOrder, updateGroupMessage };
};
